const hideGridLineNear = (gridLines: SVGLineElement[], targetTop: number): void => {
  const hiddenGridLine = gridLines.reduce<SVGLineElement | null>((closest, line) => {
    if (!closest) return line;
    const lineDistance = Math.abs(line.getBoundingClientRect().top - targetTop);
    const closestDistance = Math.abs(closest.getBoundingClientRect().top - targetTop);
    return lineDistance < closestDistance ? line : closest;
  }, null);

  if (!hiddenGridLine) return;
  const hiddenDistance = Math.abs(hiddenGridLine.getBoundingClientRect().top - targetTop);
  if (hiddenDistance > 2) return;
  hiddenGridLine.style.visibility = 'hidden';
};

export const syncStackedBarChartHorizontalGridLines = (
  container: HTMLDivElement,
  showHorizontalGrid: boolean,
): void => {
  const horizontalGridLines = Array.from(
    container.querySelectorAll('.MuiChartsGrid-horizontalLine'),
  ).filter((line): line is SVGLineElement => line instanceof SVGLineElement);

  for (const gridLine of horizontalGridLines) {
    gridLine.style.strokeWidth = showHorizontalGrid ? '0.75px' : '';
    gridLine.style.opacity = showHorizontalGrid ? '1' : '';
    gridLine.style.visibility = 'visible';
  }

  if (!showHorizontalGrid || horizontalGridLines.length === 0) return;

  const xAxisLine = container.querySelector('.MuiChartsAxis-directionX .MuiChartsAxis-line');
  if (!(xAxisLine instanceof SVGGraphicsElement)) return;

  const xAxisRect = xAxisLine.getBoundingClientRect();
  hideGridLineNear(horizontalGridLines, xAxisRect.top);

  const topFrameLine = container.querySelector('[data-chart-axis="top"]');
  if (!(topFrameLine instanceof HTMLElement)) return;
  hideGridLineNear(horizontalGridLines, topFrameLine.getBoundingClientRect().top);
};
